import { Injectable } from '@angular/core';
import {
  AbstractControlOptions,
  UntypedFormArray,
  Validators,
} from '@angular/forms';
import { PrFormAbstract } from '@app/components/pr-form/pr-form.abstract';
import FormGroupArray from '@app/forms/subscription/services/FormGroupArray';

@Injectable({
  providedIn: 'root',
})
export abstract class EaSubscriptionBuilder extends PrFormAbstract {
  generateForm(entity: any, option) {
    let options: AbstractControlOptions = {};
    const sessionConsultant = option?.sessionConsultant;
    const isCristalisOrganization = option?.isCristalisOrganization || false;

    const fieldRequired = !isCristalisOrganization ? true : !sessionConsultant;

    const formConfig = {
      ownerId: [entity?.ownerId],
      userLastName: [entity?.userLastName || null],
      userFirstName: [entity?.userFirstName ? entity.userFirstName : null],
      userNifCode: [
        entity?.userNifCode || option?.userNifCode || null,
        [
          fieldRequired ? Validators.required : null,
          Validators.minLength(7),
          Validators.maxLength(13),
        ].filter(validator => validator !== null),
      ],
    };

    return this.formBuilder.group(formConfig, options);
  }
  generate(entity: any[], option) {
    return FormGroupArray.generate({
      entity,
      options: option,
      formBuilder: this.formBuilder,
      generateForm: this.generateForm.bind(this),
    });
  }

  extract() {
    return this.form.value.owners;
  }
  get owners() {
    return this.form.get('owners') as UntypedFormArray;
  }
}
